import { render } from "./homeProntuario.vue?vue&type=template&id=018ec500&scoped=true"
import script from "./homeProntuario.vue?vue&type=script&lang=js"
export * from "./homeProntuario.vue?vue&type=script&lang=js"

import "./homeProntuario.vue?vue&type=style&index=0&id=018ec500&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018ec500"]])

export default __exports__